import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../../lib/utils';

export interface RailIconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  children: React.ReactNode;
  asLink?: string;
  asLinkState?: Record<string, unknown>;
  active?: boolean;
  activeClassName?: string;
}

/** Icon button for collapsed rails (32px). Uses native title tooltip to avoid overflow clipping. */
export const RailIconButton = React.forwardRef<HTMLButtonElement, RailIconButtonProps>(
  ({ label, children, className, asLink, asLinkState, active, activeClassName, ...props }, ref) => {
    const baseClass = cn(
      'flex h-10 w-10 max-w-full shrink-0 items-center justify-center rounded-xl transition-all duration-200',
      'text-slate-400 hover:bg-white/[0.08] hover:text-slate-100',
      className,
      active && (activeClassName ?? 'bg-indigo-500/25 text-white shadow-lg shadow-indigo-950/40 ring-1 ring-indigo-400/35'),
    );

    if (asLink) {
      return (
        <Link to={asLink} state={asLinkState} className={baseClass} aria-label={label} title={label}>
          {children}
        </Link>
      );
    }

    return (
      <button ref={ref} type="button" className={baseClass} aria-label={label} title={label} {...props}>
        {children}
      </button>
    );
  }
);

RailIconButton.displayName = 'RailIconButton';

export default RailIconButton;
